export type PaymentMethod = 'cash' | 'card' | 'online' | 'transfer'

/** The methods staff can pick at the desk. 'online' is only ever set by Stripe. */
export type DeskPaymentMethod = Exclude<PaymentMethod, 'online'>

/**
 * Badge colours for how an order was paid. Shared by the invoices table and
 * the invoice modal so the two never disagree about what an online sale looks
 * like.
 */
export function paymentMethodBadgeClass(method: PaymentMethod): string {
  if (method === 'cash') return 'bg-success/15 text-success-700'
  if (method === 'online') return 'bg-primary/10 text-primary'
  if (method === 'transfer') return 'bg-warning/15 text-warning-700'
  return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
}

/**
 * Whether staff may delete this order. An online order is the record of a
 * Stripe charge, and the Worker refuses to delete it: its checkout session id
 * is what stops a replayed webhook from granting the plan a second time.
 * Refunds are issued from the gym's Stripe dashboard instead.
 */
export function canDeleteOrder(method: PaymentMethod): boolean {
  return method !== 'online'
}
